module.exports = __webpack_public_path__ + "static/img/frackIcon2.dafcf1c2.png";